export default "__VITE_ASSET__7ALw2D6v__"